// AUTO-GENERATED by scripts/generate-version.js — do not edit.
export const APP_VERSION = "0.0.196";
export const BUILD_DATE = "2026-10-16T06:15:25.126Z";
